import { Box, Button, Stack, TextField } from '@mui/material';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { DialogPlanLlmPrompt } from '../../api/DialogPlanLlmPromptApi';
import { DialogPromptConversationListen, IDialogPromptSentence, SPEAKER_NAME_A, SPEAKER_NAME_B } from '../../api/DialogPromptApi';
import { IDialogPromptConversation } from '../../api/DialogPromptConversationApi';
import AppBarContext from '../../context/AppBarContext';
import { useConversationPinyin } from '../../hook/useConversationPinyin';

interface DialogPlanLlmPromptConversationListenGeneratedProps {
    dialogPrompt?: DialogPromptConversationListen; // if llmPrompt was generated
    dialogPromptConversation?: IDialogPromptConversation | null; // if llmPrompt was generated
    onSubmit?: (updatedDialogPlanLlmPrompt: DialogPlanLlmPrompt, setIsSaving: React.Dispatch<React.SetStateAction<boolean>>) => void;
    onDelete?: (dialogPlanLlmPromptId: number) => void;

    isRegenerating?: boolean;
    handleLlmPromptChange?: (dialogPlanLlmPrompt: DialogPlanLlmPrompt) => void;
    handleRegenerateDialogPlanLlmPrompt?: (dialogPlanLlmPrompt: DialogPlanLlmPrompt, fieldName: string) => void;
}

const DialogPlanLlmPromptConversationListenGenerated: React.FC<DialogPlanLlmPromptConversationListenGeneratedProps> = ({ dialogPrompt, dialogPromptConversation }) => {

    const { setErrorMessage } = React.useContext(AppBarContext)
    const history = useHistory();
    const location = useLocation();

    // const [dialogPromptConversationText, setDialogPromptConversationText] = React.useState("");
    const {
        conversationText,
        conversationPinyin,
        conversationPinyinList,
        conversationErrorText,
        setConversationFields,
        clearConversationErrors,
        handleConversationTextChange,
        handleConversationPinyinChange,
    } = useConversationPinyin({ history, location, setErrorMessage });

    React.useEffect(() => {
        if (dialogPrompt) {
            setDialogPromptFields();
        }
    }, [dialogPrompt])

    function setDialogPromptFields() {
        // setDialogPromptConversationText(dialogPrompt.dialog_prompt_conversation ? dialogPrompt.dialog_prompt_conversation : "")
    }
    React.useEffect(() => {
        if (dialogPromptConversation) {
            setConversationFields(dialogPromptConversation.dialog_prompt_sentence_list)
            clearConversationErrors()
            // // setDialogPromptConversationText(dialogPromptConversation.dialog_prompt_sentence_list)
            // setDialogPromptConversationText(dialogPromptConversation.dialog_prompt_sentence_list
            //     ? dialogPromptConversation.dialog_prompt_sentence_list
            //         .map(item => item.sentence_text)
            //         .join("\n") // Convert array to newline-separated string
            //     : ""
            // )
        }
    }, [clearConversationErrors, dialogPromptConversation, setConversationFields])

    // // update dialog prompt
    // const handleDialogPromptConversationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const conversationText = e.target.value;
    //     setDialogPromptConversationText(conversationText);
    //     if (dialogPromptConversation) {
    //         const lines = conversationText.split("\n").filter(line => line.trim() !== "");

    //         // Map each line to an IDialogPromptSentence object
    //         dialogPromptConversation.dialog_prompt_sentence_list = lines.map((studentResponse, index) => ({
    //             id: 0, // Assuming `id` is generated by the backend
    //             sentence_id: 0, // Assuming this is set later or generated by the backend
    //             sentence_text: studentResponse.trim(), // Assign the trimmed response
    //             speaker_name: index % 2 === 0 ? SPEAKER_NAME_A : SPEAKER_NAME_B,
    //             order_index: index + 1, // Incremental order based on line position
    //         }));
    //     }
    // };
    React.useEffect(() => {
        if (dialogPromptConversation) {
            // Convert newline-separated string to array
            const dialogPromptSentenceList: IDialogPromptSentence[] = conversationText.split("\n").map((response: string, index: number) => {
                const pinyinRaw = conversationPinyinList.length > index ? conversationPinyinList[index] : '';
                const pinyinList = pinyinRaw.trim().split(/\s+/).filter(Boolean);
                return {
                    id: 0,
                    dialog_prompt_id: dialogPrompt ? dialogPrompt.id : undefined,
                    sentence_id: 0,
                    sentence_text: response,
                    sentence_text_pinyin: pinyinList,
                    speaker_name: index % 2 === 0 ? SPEAKER_NAME_A : SPEAKER_NAME_B,
                    order_index: index
                }
            });
            dialogPromptConversation.dialog_prompt_sentence_list = dialogPromptSentenceList
        }
    }, [conversationText, conversationPinyinList, dialogPrompt, dialogPromptConversation])

    return (<>
        <Stack spacing={4} sx={{ width: '100%', margin: '0 auto', pt: 2, pb: 4 }}>

            <TextField
                label="Conversation Dialog"
                value={conversationText}
                onChange={handleConversationTextChange}
                multiline
                rows={6}
                inputProps={{
                    style: {
                        resize: 'vertical',
                        overflow: 'hidden',
                    },
                }}
            />
            <TextField
                label="Conversation Pinyin"
                value={conversationPinyin}
                onChange={handleConversationPinyinChange}
                multiline
                rows={6}
                sx={{ width: '100%' }}
                required
                error={conversationErrorText != null}
                helperText={conversationErrorText}
                inputProps={{
                    style: {
                        resize: 'vertical',
                        overflow: 'hidden',
                    },
                }}
            />
            {/* Hidden spacer button */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Button variant="contained"
                    disabled={true}
                    sx={{ opacity: 0 }}
                >
                    Regenerate
                </Button>
            </Box>
        </Stack>
    </>);
};

export default DialogPlanLlmPromptConversationListenGenerated;